import {put, select} from 'redux-saga/effects';
import {TalkViewerState} from '../state/TalkViewerState.interface';
import {stopMedia} from '../state/talkViewerSlice';
import {selectTalkViewerState} from './selector';

export function* stopAllMedia() {
  const talkViewerState: TalkViewerState = yield select(selectTalkViewerState);
  const {movie, sound, bgm} = talkViewerState;
  if (movie) {
    yield put(stopMedia(movie.talkId));
  }
  if (sound) {
    yield put(stopMedia(sound.talkId));
  }
  if (bgm) {
    yield put(stopMedia(bgm.talkId));
  }
}
